/**
 * ZOO38 Analytics Tracker - Наш личный Hotjar
 * Отслеживает все действия пользователей на сайте
 */

class ZOO38Analytics {
    constructor() {
        this.sessionId = null;
        this.playerId = null;
        this.isTracking = false;
        this.eventQueue = [];
        this.lastMousePosition = { x: 0, y: 0 };
        this.mouseMovements = [];
        this.scrollPosition = 0;
        this.sessionStartTime = Date.now();
        this.pageStartTime = Date.now();
        this.viewport = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        
        this.init();
    }
    
    init() {
        console.log('📊 ZOO38 Analytics инициализирован');
        this.setupEventListeners();
        this.startPeriodicFlush();
        // Запускаем сессию сразу для гостей
        setTimeout(() => {
            if (!this.sessionId) {
                this.startSession();
            }
        }, 1000);
    }
    
    async startSession() {
        try {
            // Получаем информацию о браузере
            const browserInfo = this.getBrowserInfo();
            const screenResolution = `${screen.width}x${screen.height}`;
            
            const response = await fetch(`${window.GAME_CFG.apiBase}/analytics/session/start`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                mode: 'cors',
                body: JSON.stringify({
                    player_id: this.playerId,
                    page_url: window.location.href,
                    screen_resolution: screenResolution,
                    browser_info: browserInfo,
                    country: 'Unknown', // Можно добавить определение по IP
                    city: 'Unknown'
                })
            });
            
            const data = await response.json();
            if (data.success) {
                this.sessionId = data.session_id;
                this.isTracking = true;
                console.log('✅ Сессия аналитики начата:', this.sessionId);
            }
        } catch (error) {
            if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
                console.log('⚠️ Analytics API недоступен (CORS), продолжаем без аналитики');
            } else {
                console.error('❌ Ошибка начала сессии аналитики:', error);
            }
        }
    }
    
    setupEventListeners() {
        // Клики
        document.addEventListener('click', (e) => {
            this.trackEvent('click', {
                x: e.clientX,
                y: e.clientY,
                element_id: e.target.id,
                element_class: e.target.className,
                element_tag: e.target.tagName,
                element_text: e.target.textContent?.substring(0, 100),
                page_url: window.location.href,
                viewport_width: this.viewport.width,
                viewport_height: this.viewport.height,
                scroll_position: window.pageYOffset
            });
        });
        
        // Движения мыши
        document.addEventListener('mousemove', (e) => {
            this.lastMousePosition = { x: e.clientX, y: e.clientY };
            this.mouseMovements.push({
                x: e.clientX,
                y: e.clientY,
                timestamp: Date.now()
            });
            
            // Ограничиваем количество движений
            if (this.mouseMovements.length > 100) {
                this.mouseMovements = this.mouseMovements.slice(-50);
            }
        });
        
        // Прокрутка
        let scrollTimeout;
        window.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                this.trackEvent('scroll', {
                    scroll_position: window.pageYOffset,
                    scroll_depth: this.getScrollDepth(),
                    page_url: window.location.href,
                    viewport_width: this.viewport.width,
                    viewport_height: this.viewport.height
                });
            }, 100);
        });
        
        // Фокус на формах
        document.addEventListener('focus', (e) => {
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
                this.trackEvent('form_focus', {
                    element_id: e.target.id,
                    element_class: e.target.className,
                    element_type: e.target.type,
                    page_url: window.location.href
                });
            }
        }, true);
        
        // Ввод в формы
        document.addEventListener('input', (e) => {
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
                this.trackEvent('form_input', {
                    element_id: e.target.id,
                    element_class: e.target.className,
                    element_type: e.target.type,
                    input_length: e.target.value.length,
                    page_url: window.location.href
                });
            }
        });
        
        // Отправка форм
        document.addEventListener('submit', (e) => {
            this.trackEvent('form_submit', {
                form_id: e.target.id,
                form_class: e.target.className,
                form_action: e.target.action,
                page_url: window.location.href
            });
        });
        
        // Изменение размера окна
        window.addEventListener('resize', () => {
            this.viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
        });
        
        // Покидание страницы
        window.addEventListener('beforeunload', () => {
            this.endSession();
        });
        
        // Игровые события (если игра загружена)
        this.setupGameEvents();
    }
    
    setupGameEvents() {
        // Отслеживаем игровые события через кастомные события
        document.addEventListener('gameStart', () => {
            this.trackEvent('game_start', {
                page_url: window.location.href,
                timestamp: Date.now()
            });
        });
        
        document.addEventListener('gameClick', (e) => {
            this.trackEvent('game_click', {
                x: e.detail.x,
                y: e.detail.y,
                element_type: e.detail.elementType,
                page_url: window.location.href
            });
        });
        
        document.addEventListener('gameCollect', (e) => {
            this.trackEvent('game_collect', {
                object_type: e.detail.objectType,
                object_id: e.detail.objectId,
                page_url: window.location.href
            });
        });
        
        document.addEventListener('gameRegistration', () => {
            this.trackEvent('registration', {
                page_url: window.location.href,
                timestamp: Date.now()
            });
        });
        
        document.addEventListener('gamePurchase', (e) => {
            this.trackEvent('purchase', {
                product_id: e.detail.productId,
                value: e.detail.value,
                page_url: window.location.href
            });
        });
    }
    
    trackEvent(eventType, eventData) {
        if (!this.sessionId) {
            console.log('⚠️ Аналитика: нет session_id, пропускаем событие:', eventType);
            return;
        }
        
        const event = {
            session_id: this.sessionId,
            player_id: this.playerId,
            event_type: eventType,
            event_data: eventData,
            page_url: window.location.href,
            timestamp: new Date().toISOString(),
            x_coordinate: eventData.x || this.lastMousePosition.x,
            y_coordinate: eventData.y || this.lastMousePosition.y,
            element_id: eventData.element_id,
            element_class: eventData.element_class,
            element_tag: eventData.element_tag,
            element_text: eventData.element_text,
            viewport_width: this.viewport.width,
            viewport_height: this.viewport.height,
            scroll_position: eventData.scroll_position || window.pageYOffset,
            mouse_movement: JSON.stringify(this.mouseMovements.slice(-10)) // Последние 10 движений
        };
        
        this.eventQueue.push(event);
        console.log('📊 Событие добавлено в очередь:', eventType, this.eventQueue.length);
        
        // Если очередь большая, отправляем сразу
        if (this.eventQueue.length >= 10) {
            this.flushEvents();
        }
    }
    
    async flushEvents() {
        if (this.eventQueue.length === 0) return;
        
        const eventsToSend = [...this.eventQueue];
        this.eventQueue = [];
        
        try {
            const response = await fetch(`${window.GAME_CFG.apiBase}/analytics/event`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(eventsToSend)
            });
            
            if (!response.ok) {
                console.error('❌ Ошибка отправки событий аналитики');
                // Возвращаем события в очередь при ошибке
                this.eventQueue.unshift(...eventsToSend);
            }
        } catch (error) {
            console.error('❌ Ошибка отправки событий аналитики:', error);
            // Возвращаем события в очередь при ошибке
            this.eventQueue.unshift(...eventsToSend);
        }
    }
    
    startPeriodicFlush() {
        // Отправляем события каждые 5 секунд
        setInterval(() => {
            this.flushEvents();
        }, 5000);
    }
    
    async endSession() {
        if (!this.sessionId) return;
        
        try {
            // Отправляем оставшиеся события
            await this.flushEvents();
            
            const duration = Math.floor((Date.now() - this.sessionStartTime) / 1000);
            
            await fetch(`${window.GAME_CFG.apiBase}/analytics/session/end`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    session_id: this.sessionId,
                    duration_seconds: duration
                })
            });
            
            console.log('✅ Сессия аналитики завершена');
        } catch (error) {
            console.error('❌ Ошибка завершения сессии аналитики:', error);
        }
    }
    
    getBrowserInfo() {
        const ua = navigator.userAgent;
        const browser = this.getBrowserName(ua);
        const os = this.getOSName(ua);
        
        return `${browser} on ${os}`;
    }
    
    getBrowserName(userAgent) {
        if (userAgent.includes('Chrome')) return 'Chrome';
        if (userAgent.includes('Firefox')) return 'Firefox';
        if (userAgent.includes('Safari')) return 'Safari';
        if (userAgent.includes('Edge')) return 'Edge';
        return 'Unknown';
    }
    
    getOSName(userAgent) {
        if (userAgent.includes('Windows')) return 'Windows';
        if (userAgent.includes('Mac')) return 'macOS';
        if (userAgent.includes('Linux')) return 'Linux';
        if (userAgent.includes('Android')) return 'Android';
        if (userAgent.includes('iOS')) return 'iOS';
        return 'Unknown';
    }
    
    getScrollDepth() {
        const scrollTop = window.pageYOffset;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        return Math.round((scrollTop / docHeight) * 100);
    }
    
    // Публичные методы для интеграции с игрой
    setPlayerId(playerId) {
        this.playerId = playerId;
        console.log('👤 Player ID установлен в аналитике:', playerId || 'Guest');
        // Запускаем сессию когда получили player_id (даже если null для гостей)
        if (!this.sessionId) {
            this.startSession();
        }
    }
    
    trackGameEvent(eventType, data) {
        this.trackEvent(eventType, data);
    }
}

// Инициализируем аналитику
window.zoo38Analytics = new ZOO38Analytics();

// Экспортируем для использования в других скриптах
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ZOO38Analytics;
}
